import {CurrencyCode, FALLBACK_CURRENCIES} from "../../domain/currency.types";

/**
 * Maps API response to domain currency codes.
 * Tolerant reader: handles missing/malformed data gracefully.
 *
 * Pure TypeScript - no React imports.
 */

/**
 * Expected API response shape (v1 and v2 general/currencies).
 * API returns { data: string[] }.
 */
interface CurrenciesApiResponse {
  data?: unknown;
}

/**
 * Converts API response to domain currency codes.
 * Returns FALLBACK_CURRENCIES if response is invalid.
 *
 * @param apiResponse - Raw API response (unknown for tolerant reading)
 * @returns Array of currency codes
 */
export function toDomainCurrencies(apiResponse: unknown): CurrencyCode[] {
  if (apiResponse == null || typeof apiResponse !== "object") {
    return [...FALLBACK_CURRENCIES];
  }

  const response = apiResponse as CurrenciesApiResponse;
  const data = response.data;

  if (data == null) {
    return [...FALLBACK_CURRENCIES];
  }

  if (!Array.isArray(data)) {
    return [...FALLBACK_CURRENCIES];
  }

  return data.filter(
    (item): item is string => typeof item === "string" && item.length > 0
  );
}
